/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionSdkTrainingTokenResponse } from '../../models/vision-sdk-training-token-response';

export interface VisionSdkRefreshPost$Params {
}

export function visionSdkRefreshPost(http: HttpClient, rootUrl: string, params?: VisionSdkRefreshPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<VisionSdkTrainingTokenResponse>> {
  const rb = new RequestBuilder(rootUrl, visionSdkRefreshPost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<VisionSdkTrainingTokenResponse>;
    })
  );
}

visionSdkRefreshPost.PATH = '/VisionSdk/Refresh';
